const FILTER_SOURCE_TYPES = {
    definitions: 'definitions',
    currencies: 'currencies',
    countries: 'countries',
    paymentCardBrands: 'paymentCardBrands',
    rebillyAPI: 'rebillyAPI',
    enum: 'enum',
};

export default FILTER_SOURCE_TYPES;
